// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prac-list-wrapper_v3 {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    max-height: 520px;
    overflow-y: auto;
    padding: 1rem;
    border: 1px solid var(--clr-primary-2);
    border-radius: 12px;
    background-color: var(--clr-white);
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.02);
  }
  
  .prac-list-wrapper_v3::-webkit-scrollbar {
    width: 8px;
  }
  .prac-list-wrapper_v3::-webkit-scrollbar-thumb {
    background-color: var(--clr-primary-6);
    border-radius: 4px;
  }
  
  .prac-card-full_v3 {
    width: 100%;
    border: 1px solid var(--clr-grey-3);
    border-radius: 12px;
    padding: 1.25rem;
    background-color: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.035);
    transition: box-shadow 0.3s ease;
  }
  
  .prac-card-full_v3:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  }
  
  .prac-name_v3 {
    font-weight: 600;
    color: var(--clr-grey-1);
    font-size: 1.15rem;
    margin-bottom: 0.75rem;
    letter-spacing: 0.25px;
  }
  
  .slot-flex-box_v3 {
    display: flex;
    flex-wrap: wrap;
    gap: 0.6rem;
    align-items: flex-start;
    padding: 8px 12px;
  }

  .slot-btn_v3 {
    background-color: var(--clr-grey-10);
    border: 1px solid var(--clr-grey-6);
    color: var(--clr-grey-2);
    padding: 0.5rem 1rem;
    border-radius: 8px;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 500;
    width: 175px;       
    min-height: 42px;
    text-align: center;
    white-space: nowrap;
    box-sizing: border-box;
    transition: background-color 0.2s ease, transform 0.2s ease;
  }
  
  .slot-btn_v3:hover {
    background-color: var(--clr-grey-8);
    transform: scale(1.03);
  }
  
  
  .slot-btn_v3.selected {
    background-color: var(--clr-primary-5);
    color: white;
    border-color: var(--clr-primary-6);
  }
  
  @media (max-width: 480px) {
    .slot-flex-box_v3 {
      justify-content: center;
    }
  
    .slot-btn_v3 {
      width: calc(50% - 0.4rem);
    }
  }
  
  
  @media (min-width: 481px) and (max-width: 768px) {
    .slot-btn_v3 {
      width: calc(33.33% - 0.4rem);
    }
  }

  .no-slots_v3 {
    font-size: 0.95rem;
    color: var(--clr-grey-6);
    margin-top: 0.5rem;
  }
  
  .no-pracs-message_v3 {
    padding: 2rem;
    text-align: center;
    /* color: var(--clr-grey-7); */
    font-size: 1rem;
    border: 1px dashed var(--clr-grey-4);
    border-radius: 10px;
    background-color: var(--clr-white);
    margin-bottom: 1rem;
  }
  
  /* Responsive Enhancements */
  @media (max-width: 768px) {
    .prac-card-full_v3 {
      padding: 1rem;
    }
  
    .slot-flex-box_v3 {
      gap: 0.5rem;
    }
  
    .slot-btn_v3 {
      padding: 0.45rem 0.75rem;
      font-size: 0.85rem;
    }
  
    .prac-name_v3 {
      font-size: 1.05rem;
    }
  }
  
  @media (max-width: 480px) {
    .slot-btn_v3 {
      font-size: 0.7rem;
      padding: 0.4rem 0.65rem;
    }
  
    .prac-card-full_v3 {
      padding: 0.9rem;
    }
  
    .prac-name_v3 {
      font-size: 1rem;
    }
  }
  
  .prac-header_v3 {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
  }
  
  .prac-name-group_v3 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.4rem;
  }
  
  .prac-name_v3 {
    font-weight: 600;
    /* color: var(--clr-primary-9); */
    font-size: 1.15rem;
    letter-spacing: 0.25px;
    margin: 0;
  }
  
  .prac-gender_v3 {
    font-weight: normal;
    color: var(--clr-grey-5);
    font-size: 0.95rem;
  }
  
  .prac-badges_v3 {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    align-items: center;
    justify-content: flex-end;
    flex-grow: 1;
    margin-bottom: 1rem;
  }
  
  .badge_v3 {
    margin-top: 10px;
    padding: 8px 12px;
    font-size: 0.9rem;
    font-weight: 500;
    border-radius: 6px;
    display: inline-block;
    transition: var(--transition);
  }
  
  .licensed_v3 {
    background-color: var(--green-light);
    color: var(--green-dark);
    border: 1px solid var(--green-dark);
  }
  
  .fee-badge_v3 {
    display: inline-block;
  margin-top: 10px;
  padding: 8px 12px;
  background-color: var(--clr-primary-10);
  color: var(--clr-grey-1);
  border: 1px solid var(--clr-primary-6);
  border-radius: var(--radius);
  font-size: 0.95rem;
  font-weight: 500;
  transition: var(--transition);
  }
  

  @media (max-width: 480px) {
    .prac-header_v3 {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
    }
  
    .prac-badges_v3 {
      justify-content: flex-start;
    }
  }
  
  .loading-spinner_v3 {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem 0;
    text-align: center;
    color: var(--clr-grey-6);
    font-size: 1rem;
    position: relative;
  }
  
  .loading-spinner_v3::before {
    content: "";
    width: 1.25rem;
    height: 1.25rem;
    margin-right: 0.75rem;
    border: 3px solid var(--clr-grey-5);
    border-top-color: var(--clr-primary-7);
    border-radius: 50%;
    animation: spinLoader 0.8s linear infinite;
  }
  
  @keyframes spinLoader {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  
  
  .not-licensed_v3 {
    background-color: var(--red-light);
    color: var(--red-dark);
    border: 1px solid var(--red-dark);
  }
  
  .gender-label_v3 {
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--clr-grey-2);
  margin-left: 0.25rem;
  padding: 2px 6px;
  background-color: var(--clr-grey-8);
  border-radius: 12px;
  vertical-align: middle;
  display: inline-block;
}

.prac-skills-line_v3 {
  background-color: var(--skill-bg, #e8f4ff);
  border: 1px solid var(--skill-border, #cce5ff);
  padding: 12px 16px;
  border-radius: 8px;
  margin: 10px 12px 18px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
}

.skills-title_v3 {
  font-size: 0.95rem;
  margin-bottom: 6px;
  color: var(--skill-title-color, #003366);
}

.skills-tags_v3 {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.skill-tag_v3 {
  background-color: #ffffff;
  border: 1px solid #007bff;
  color: #007bff;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 500;
  box-shadow: 0 0 2px rgba(0, 123, 255, 0.2);
}

`, "",{"version":3,"sources":["webpack://./src/components/NewAdminScheduling/styles/AdminPractitionerSlotGrid.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,sCAAsC;IACtC,mBAAmB;IACnB,kCAAkC;IAClC,+CAA+C;EACjD;;EAEA;IACE,UAAU;EACZ;EACA;IACE,sCAAsC;IACtC,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,mCAAmC;IACnC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,0CAA0C;IAC1C,gCAAgC;EAClC;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,WAAW;IACX,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,oCAAoC;IACpC,mCAAmC;IACnC,wBAAwB;IACxB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,2DAA2D;EAC7D;;EAEA;IACE,mCAAmC;IACnC,sBAAsB;EACxB;;;EAGA;IACE,sCAAsC;IACtC,YAAY;IACZ,kCAAkC;EACpC;;EAEA;IACE;MACE,uBAAuB;IACzB;;IAEA;MACE,yBAAyB;IAC3B;EACF;;;EAGA;IACE;MACE,4BAA4B;IAC9B;EACF;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,eAAe;IACf,oCAAoC;IACpC,mBAAmB;IACnB,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA,4BAA4B;EAC5B;IACE;MACE,aAAa;IACf;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,wBAAwB;MACxB,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,iBAAiB;MACjB,uBAAuB;IACzB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;IACjC,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,6BAA6B;EAC/B;;EAEA;IACE,oCAAoC;IACpC,wBAAwB;IACxB,mCAAmC;EACrC;;EAEA;IACE,qBAAqB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,uCAAuC;EACvC,wBAAwB;EACxB,sCAAsC;EACtC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B;;;EAGA;IACE;MACE,sBAAsB;MACtB,uBAAuB;MACvB,WAAW;IACb;;IAEA;MACE,2BAA2B;IAC7B;EACF;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,mCAAmC;IACnC,sCAAsC;IACtC,kBAAkB;IAClB,0CAA0C;EAC5C;;EAEA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;;EAGA;IACE,kCAAkC;IAClC,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA;EACA,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C","sourcesContent":[".prac-list-wrapper_v3 {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    max-height: 520px;\n    overflow-y: auto;\n    padding: 1rem;\n    border: 1px solid var(--clr-primary-2);\n    border-radius: 12px;\n    background-color: var(--clr-white);\n    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.02);\n  }\n  \n  .prac-list-wrapper_v3::-webkit-scrollbar {\n    width: 8px;\n  }\n  .prac-list-wrapper_v3::-webkit-scrollbar-thumb {\n    background-color: var(--clr-primary-6);\n    border-radius: 4px;\n  }\n  \n  .prac-card-full_v3 {\n    width: 100%;\n    border: 1px solid var(--clr-grey-3);\n    border-radius: 12px;\n    padding: 1.25rem;\n    background-color: white;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.035);\n    transition: box-shadow 0.3s ease;\n  }\n  \n  .prac-card-full_v3:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\n  }\n  \n  .prac-name_v3 {\n    font-weight: 600;\n    color: var(--clr-grey-1);\n    font-size: 1.15rem;\n    margin-bottom: 0.75rem;\n    letter-spacing: 0.25px;\n  }\n  \n  .slot-flex-box_v3 {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.6rem;\n    align-items: flex-start;\n    padding: 8px 12px;\n  }\n\n  .slot-btn_v3 {\n    background-color: var(--clr-grey-10);\n    border: 1px solid var(--clr-grey-6);\n    color: var(--clr-grey-2);\n    padding: 0.5rem 1rem;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 0.9rem;\n    font-weight: 500;\n    width: 175px;       \n    min-height: 42px;\n    text-align: center;\n    white-space: nowrap;\n    box-sizing: border-box;\n    transition: background-color 0.2s ease, transform 0.2s ease;\n  }\n  \n  .slot-btn_v3:hover {\n    background-color: var(--clr-grey-8);\n    transform: scale(1.03);\n  }\n  \n  \n  .slot-btn_v3.selected {\n    background-color: var(--clr-primary-5);\n    color: white;\n    border-color: var(--clr-primary-6);\n  }\n  \n  @media (max-width: 480px) {\n    .slot-flex-box_v3 {\n      justify-content: center;\n    }\n  \n    .slot-btn_v3 {\n      width: calc(50% - 0.4rem);\n    }\n  }\n  \n  \n  @media (min-width: 481px) and (max-width: 768px) {\n    .slot-btn_v3 {\n      width: calc(33.33% - 0.4rem);\n    }\n  }\n\n  .no-slots_v3 {\n    font-size: 0.95rem;\n    color: var(--clr-grey-6);\n    margin-top: 0.5rem;\n  }\n  \n  .no-pracs-message_v3 {\n    padding: 2rem;\n    text-align: center;\n    /* color: var(--clr-grey-7); */\n    font-size: 1rem;\n    border: 1px dashed var(--clr-grey-4);\n    border-radius: 10px;\n    background-color: var(--clr-white);\n    margin-bottom: 1rem;\n  }\n  \n  /* Responsive Enhancements */\n  @media (max-width: 768px) {\n    .prac-card-full_v3 {\n      padding: 1rem;\n    }\n  \n    .slot-flex-box_v3 {\n      gap: 0.5rem;\n    }\n  \n    .slot-btn_v3 {\n      padding: 0.45rem 0.75rem;\n      font-size: 0.85rem;\n    }\n  \n    .prac-name_v3 {\n      font-size: 1.05rem;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .slot-btn_v3 {\n      font-size: 0.7rem;\n      padding: 0.4rem 0.65rem;\n    }\n  \n    .prac-card-full_v3 {\n      padding: 0.9rem;\n    }\n  \n    .prac-name_v3 {\n      font-size: 1rem;\n    }\n  }\n  \n  .prac-header_v3 {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    gap: 0.75rem;\n    margin-bottom: 0.75rem;\n  }\n  \n  .prac-name-group_v3 {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0.4rem;\n  }\n  \n  .prac-name_v3 {\n    font-weight: 600;\n    /* color: var(--clr-primary-9); */\n    font-size: 1.15rem;\n    letter-spacing: 0.25px;\n    margin: 0;\n  }\n  \n  .prac-gender_v3 {\n    font-weight: normal;\n    color: var(--clr-grey-5);\n    font-size: 0.95rem;\n  }\n  \n  .prac-badges_v3 {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    align-items: center;\n    justify-content: flex-end;\n    flex-grow: 1;\n    margin-bottom: 1rem;\n  }\n  \n  .badge_v3 {\n    margin-top: 10px;\n    padding: 8px 12px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    border-radius: 6px;\n    display: inline-block;\n    transition: var(--transition);\n  }\n  \n  .licensed_v3 {\n    background-color: var(--green-light);\n    color: var(--green-dark);\n    border: 1px solid var(--green-dark);\n  }\n  \n  .fee-badge_v3 {\n    display: inline-block;\n  margin-top: 10px;\n  padding: 8px 12px;\n  background-color: var(--clr-primary-10);\n  color: var(--clr-grey-1);\n  border: 1px solid var(--clr-primary-6);\n  border-radius: var(--radius);\n  font-size: 0.95rem;\n  font-weight: 500;\n  transition: var(--transition);\n  }\n  \n\n  @media (max-width: 480px) {\n    .prac-header_v3 {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0.5rem;\n    }\n  \n    .prac-badges_v3 {\n      justify-content: flex-start;\n    }\n  }\n  \n  .loading-spinner_v3 {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 2rem 0;\n    text-align: center;\n    color: var(--clr-grey-6);\n    font-size: 1rem;\n    position: relative;\n  }\n  \n  .loading-spinner_v3::before {\n    content: \"\";\n    width: 1.25rem;\n    height: 1.25rem;\n    margin-right: 0.75rem;\n    border: 3px solid var(--clr-grey-5);\n    border-top-color: var(--clr-primary-7);\n    border-radius: 50%;\n    animation: spinLoader 0.8s linear infinite;\n  }\n  \n  @keyframes spinLoader {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  \n  \n  .not-licensed_v3 {\n    background-color: var(--red-light);\n    color: var(--red-dark);\n    border: 1px solid var(--red-dark);\n  }\n  \n  .gender-label_v3 {\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--clr-grey-2);\n  margin-left: 0.25rem;\n  padding: 2px 6px;\n  background-color: var(--clr-grey-8);\n  border-radius: 12px;\n  vertical-align: middle;\n  display: inline-block;\n}\n\n.prac-skills-line_v3 {\n  background-color: var(--skill-bg, #e8f4ff);\n  border: 1px solid var(--skill-border, #cce5ff);\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin: 10px 12px 18px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.06);\n}\n\n.skills-title_v3 {\n  font-size: 0.95rem;\n  margin-bottom: 6px;\n  color: var(--skill-title-color, #003366);\n}\n\n.skills-tags_v3 {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.skill-tag_v3 {\n  background-color: #ffffff;\n  border: 1px solid #007bff;\n  color: #007bff;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  box-shadow: 0 0 2px rgba(0, 123, 255, 0.2);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
